module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125838.5bb36e4d.jpg";